import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { CustomerScanComponent } from './pages/customer-scan/customer-scan.component';
import { HomeComponent } from './pages/home/home.component'; 
import { LoginComponent } from './login/login.component';
import { APIServiceInterceptor } from 'src/api-providers/interceptors/APIService.interceptor';
import { SocialLoginModule, SocialAuthServiceConfig } from '@abacritt/angularx-social-login';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { GoogleLoginProvider } from '@abacritt/angularx-social-login';
import { ComponentsModule } from './components/components.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
 
 

@NgModule({
  declarations: [
    AppComponent,
    CustomerScanComponent,
    HomeComponent,
    LoginComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    NgbModule,
    AppRoutingModule,
    HttpClientModule,
    SocialLoginModule,
    ComponentsModule,
    InfiniteScrollModule,
  
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: APIServiceInterceptor,
      multi: true
    }
    ,
    {
      provide: 'SocialAuthServiceConfig',
      useValue: {
        autoLogin: false,
        providers: [
          {
            id: GoogleLoginProvider.PROVIDER_ID,
            provider: new GoogleLoginProvider(
              '254591168563-kipk5fpv3b1pego7r4iavh6kuintho2r.apps.googleusercontent.com', { oneTapEnabled: false, })
          },
        ],
        onError: (err) => {
          console.error(err);
        }
      } as SocialAuthServiceConfig,
    },
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
